<script setup>
import { SPORT_LIVE_TV_STATUS_OPTIONS } from '@/sport-live-tv/constants';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  modelValue: { type: String, required: true },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="sport-live-tv-status-tabs">
    <button
      v-for="option in SPORT_LIVE_TV_STATUS_OPTIONS"
      :key="option.value"
      type="button"
      class="sport-live-tv-status-tabs__tab"
      :class="{ 'sport-live-tv-status-tabs__tab--active': option.value === modelValue }"
      :aria-pressed="option.value === modelValue"
      @click="emit('update:modelValue', option.value)"
    >
      {{ t(option.labelKey) }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-status-tabs {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  padding: 4px;
  border-radius: 10px;
  background-color: $black30;

  @include mobile-sm-max {
    justify-content: space-between;
  }

  &__tab {
    height: 36px;
    padding: 0 16px;
    border: 0;
    border-radius: 8px;
    background: none;
    color: $gray;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

    @include mobile-sm-max {
      flex: 1;
    }

    &:hover {
      background-color: $black50;
      color: $white;
    }

    &--active,
    &--active:hover {
      background-color: $bg-red;
      color: $white;
    }
  }
}
</style>
